<template>
  <div class="container d-flex justify-content-center h-100">
    <div class="row align-self-center">
      <h2 id="title" class="text-danger">{{ title }}</h2>
      <h3 v-if="summary">{{ summary }}</h3>
      <b v-if="message">{{ message }}</b>
      <slot />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'DAErrorGroup',
  props: {
    title: { type: String, required: true },
    summary: { type: String, default: '' },
    message: { type: String, required: true },
  },
});
</script>
